module.exports = __webpack_public_path__ + "img/sygnali_logo_450_black.5de9d499.png";